/**
 * Workout library writes through the global apiClient: save (POST /api/coach/workouts/save — used
 * by the workout editor and GlobalStateProvider) and delete. Return the non-throwing ApiResponse;
 * callers turn failures into their own errors. `saveWorkout` uses `envelope: false`, so the saved
 * row is at `data.workout`.
 */

import { api, type ApiResponse } from '@/lib/apiClient';
import type { SaveWorkoutBody } from '@schemas/programs';

/** Body typed by the handler's SaveWorkoutSchema (API-6). */
export function saveWorkout(
  workout: SaveWorkoutBody['workout'],
  items: SaveWorkoutBody['items'],
): Promise<ApiResponse> {
  return api.post('/api/coach/workouts/save', { workout, items }, { envelope: false });
}

/** Soft delete by default; `hard: true` removes the row. */
export function deleteWorkout(workoutId: string, opts?: { hard?: boolean }): Promise<ApiResponse> {
  return api.delete(`/api/coach/workouts/${workoutId}${opts?.hard ? '?hard=true' : ''}`);
}
